import React, { Component } from 'react';

import './Footer.css';

import { House, Mail, Phone } from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import { IMAGES } from '../Images';
import { INDUSTRY_LINKS } from '../Data';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.quickLinks = [
      { id: 1, text: 'Home', route: '/' },
      { id: 2, text: 'Core Team', route: '/core-team' },
      { id: 3, text: 'Projects', route: '/projects' },
      { id: 4, text: 'Clients', route: '/clients' },
      { id: 5, text: 'Contact Us', route: '/contact-us' },
    ];
  }

  navigateTo = (route) => {
    this.props.history.push(route);
  };

  render() {
    const firstColumn = INDUSTRY_LINKS.slice(0, 6);
    const secondColumn = INDUSTRY_LINKS.slice(6);
    return (
      <>
        <footer className="footer">
          <div className="footer-container">
            <div className="footer-container-1">
              <div className="footer-logo">
                <img src={IMAGES.LOGO_DARK} alt="descon" />
              </div>
              <p className="footer-info">
                We are interested for Electrical Utility Shifting Work for Road Widening Projects of NHAI prefearably in
                UP and UK. We are having profound technocrats in the same field who are associated with us.
              </p>
            </div>
            <div className="footer-container-2">
              <p className="container-head">Quick links</p>

              <div className="container-links">
                {this.quickLinks.map((link) => (
                  <Button key={link.id} className="footer-links" onClick={() => this.navigateTo(link.route)}>
                    {link.text}
                  </Button>
                ))}
              </div>
            </div>

            <div className="footer-container-3">
              <p className="container-head">Industries we serve</p>
              <div className="industries-wrapper">
                <div className="industries-links-container">
                  {firstColumn.map((link, index) => (
                    <div key={index} className="industry-link">
                      <img src={link.src} alt={link.alt} />
                      <p className="footer-links">{link.text}</p>
                    </div>
                  ))}
                </div>
                <div className="industries-links-container">
                  {secondColumn.map((link, index) => (
                    <div key={index} className="industry-link">
                      <img src={link.src} alt={link.alt} />
                      <p className="footer-links">{link.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="footer-container-4">
              <p className="container-head">Address</p>
              <div className="address-row">
                <div className="address-icon">
                  <House />
                </div>
                <p>128/K - 189, 'K' Block, Kidwai Nagar Kanpur - 208011 U.P.</p>
              </div>
              <div className="address-row">
                <div className="address-icon">
                  <Phone />
                </div>
                <p>+91 - 9415052457</p>
              </div>
              <div className="address-row">
                <div className="address-icon">
                  <Mail />
                </div>
                <p>info@desconbuildtech.in</p>
              </div>
            </div>
          </div>
          <div className="footer-powered">
            <p>
              Powered by{' '}
              <a href="https://www.techbrj.com/" rel="noopener noreferrer" target="_blank">
                <span style={{ color: 'var(--primary)' }}>TechBRJ </span>
              </a>
            </p>
          </div>
        </footer>
      </>
    );
  }
}
export default withRouter(Footer);
